import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  userRoleInfo = new BehaviorSubject({});
 
  checkUserRoleEnabled(flagName){
    return this.userRoleInfo
    .pipe(
      switchMap((res) => of(res[flagName]))
    );
  }
}

export enum ACCESSIBILITY {
  SELLABILITYFLAG = 'sellabilityFlag',
  QUOTABILITYFLAG = 'quotabilityFlag'
}